<template>
  <div class="twcs-bg-gray-115 twcs-relative">
    <div class="twcs-text-base twcs-bg-white twcs-px-8">
      <p>
        We try to keep class search as up-to-date as possible, but not everything on the internet is accurate. Our information here is on a 24 hour delay. So, if you have questions about class availability, please double check with an advisor.
      </p>
    </div>
    <div :class="[
      headerOpen ? 'twcs-z-0' : 'twcs-z-[1000]',
      !isScrollingDown ? 'twcs-top-16' : 'twcs-top-0',
      'twcs-transition-all twcs-duration-300 twcs-sticky sm:twcs-z-0 sm:twcs-static twcs-mb-2 twcs-border-b-2 twcs-border-gray-115']"
    >
      <Search
        @search-modal-open-on-click="openSearchModal"
        @categories-modal-open-on-click="openCategoriesModal"
      />
    </div>
    <div class="twcs-relative twcs-mx-0 md:twcs-pt-6 md:twcs-mx-8 twcs-grid twcs-grid-cols-12 twcs-gap-2 md:twcs-gap-4">
      <div class="twcs-hidden md:twcs-block md:twcs-col-span-3">
        <Categories :is-scrolling-down="isScrollingDown" />
      </div>
      <div class="twcs-col-span-12 md:twcs-col-span-9">
        <Results @result-selected="openClassModal" />
      </div>
    </div>
    <ViewClassModal
      v-if="classModalOpen"
      :modal-open="classModalOpen"
      :modal-show="classModalShow"
      @modal-close-on-click="closeClassModal"
    />
    <SearchModal
      v-if="searchModalOpen"
      :modal-open="searchModalOpen"
      :modal-show="searchModalShow"
      @modal-close-on-click="closeSearchModal"
    />
    <CategoriesModal
      v-if="categoriesModalOpen"
      :modal-open="categoriesModalOpen"
      :modal-show="categoriesModalShow"
      @modal-close-on-click="closeCategoriesModal"
    />
  </div>
</template>

<style>
.overflow-visible {
  overflow: visible;
}
#class-search a.maintenance-link {
  -webkit-transition: border-bottom .3s ease;
  transition: border-bottom .3s ease;
  border-bottom: 0.0625em solid;
  color: inherit;
  text-decoration: none;
}
#class-search a.maintenance-link:hover {
  border-bottom-width: 0.25em;
}
</style>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { usePanelStateStore } from '@/stores/panel-state.js';
import Categories from '@/components/Categories.vue';
import CategoriesModal from '@/components/CategoriesModal.vue';
import Results from '@/components/Results.vue';
import Search from '@/components/Search.vue'
import SearchModal from '@/components/SearchModal.vue';
import ViewClassModal from '@/components/ViewClassModal.vue';

const headerNode = document.querySelector('.header__menu, .menu');
const panelState = usePanelStateStore();

let searchModalOpen = ref(false);
let searchModalShow = ref(false);

function openSearchModal(value) {
	searchModalOpen.value = value;
	setTimeout(() => {
		searchModalShow.value = value;
	}, 100);
}

function closeSearchModal(value) {
	searchModalShow.value = value;
	setTimeout(() => {
		searchModalOpen.value = value;
        panelState.updateCurrentPanel('base');
	}, 500);
}

let classModalOpen = ref(false);
let classModalShow = ref(false);

function openClassModal() {
	classModalOpen.value = true;
	setTimeout(() => {
		classModalShow.value = true;
	}, 100);
}

function closeClassModal(value) {
	classModalShow.value = value;
	setTimeout(() => {
		classModalOpen.value = value;
	}, 300);
}

let categoriesModalOpen = ref(false);
let categoriesModalShow = ref(false);

function openCategoriesModal() {
	categoriesModalOpen.value = true;
	setTimeout(() => {
		categoriesModalShow.value = true;
	}, 100);
}

function closeCategoriesModal(value) {
	categoriesModalShow.value = value;
	setTimeout(() => {
		categoriesModalOpen.value = value;
	}, 500);
}

let lastScrollPosition = ref(0);
let isScrollingDown = ref(true);

function onScroll() {
	setInterval(() => {
		const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
		if(currentScrollPosition < lastScrollPosition.value) {
			isScrollingDown.value = false;
		} else if(currentScrollPosition > lastScrollPosition.value) {
			isScrollingDown.value = true;
		}
		lastScrollPosition.value = currentScrollPosition
	}, 250);
}

let headerOpen = ref(false);

const mutationObserver = new MutationObserver(function(mutations) {
	for(const mutation of mutations) {
		if(mutation.target.classList.length > 1 && (mutation.target.classList[1] === 'header__menu--active' || mutation.target.classList[1] === 'menu--active')) {
			headerOpen.value = true;
		} else if(mutation.target.classList.length > 1 && mutation.target.classList[1] === 'focus-within') {
			headerOpen.value = false;
		}
	}
});

onMounted(() => {
	mutationObserver.observe(headerNode, { attributes: true });
	document.querySelector('.canvas, .nh-canvas').classList.add('overflow-visible');
	window.addEventListener('scroll', onScroll);
});

onBeforeUnmount(() => {
	mutationObserver.disconnect();
	window.removeEventListener('scroll', onScroll);
});
</script>
